<template lang="html">

    <v-col :cols="cols" :sm="sm" :md="md" :lg="lg" :xl="xl">
        <v-autocomplete v-if="type !== 'user' && type !== 'you'"
                        v-model="searchedGameSelected"
                        :search-input.sync="searchGame"
                        :items="searchedItems"
                        :loading="isLoading"
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="slug"
                        placeholder="Search Game..."
                        outlined
                        class="searchbar"
                        append-icon=""
        ></v-autocomplete>
        <v-autocomplete v-if="type === 'user'"
                        v-model="searchedUserSelected"
                        :search-input.sync="searchUser"
                        :items="searchedItems"
                        :loading="isLoading"
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="id"
                        placeholder="Search User..."
                        outlined
                        class="searchbar"
                        append-icon=""
        ></v-autocomplete>
    </v-col>
</template>

<script lang="js">
    import axios from "axios";
    import authHeader from "../../services/auth-header";

    export default {
        name:       'searchbar',
        props:      ['type', 'cols', 'sm', 'md', 'lg', 'xl'],
        components: {},
        mounted () {
        },
        data () {
            return {
                'searchedItems':        [],
                'isLoading':            false,
                'searchGame':           null,
                'searchUser':           null,
                'searchedGameSelected': null,
                'searchedUserSelected': null,
            }
        },
        methods:    {
            showName(name) {
                if(typeof name !== "undefined") {
                    console.log(JSON.parse(name));
                    return JSON.parse(name);
                }
            }
        },
        watch:      {
            searchGame (val) {
                if (val !== null && typeof val !== "undefined") {
                    this.isLoading = true;
                    axios.get(window.api_url + '/api/game/search/' + val, {headers: authHeader()})
                         .then(res => {
                             this.searchedItems = res.data;
                             console.log(this.searchedItems);
                         })
                         .catch(err => console.log(err))
                         .finally(() => (this.isLoading = false));
                }
            },
            searchUser (val) {
                if (val !== null && typeof val !== "undefined") {
                    this.isLoading = true;
                    axios.get(window.api_url + '/api/auth/user/search/' + val, {headers: authHeader()})
                         .then(res => {
                             this.searchedItems = res.data;
                         })
                         .catch(err => console.log(err))
                         .finally(() => (this.isLoading = false));
                }
            },
            searchedGameSelected (val) {
                this.$router.push({name: 'game', params: {slug: val}});
            },
            searchedUserSelected (val) {
                this.$router.push({name: 'user', params: {id: val}});
            }
        }
    }


</script>

<style lang="scss">
    .searchbar {
        border-radius: 100px;
    }

    .searchbar .v-select__slot {
        padding-left: 20px;
    }

    .v-autocomplete__content .v-list {
        background-color: var(--v-accent-base);
        margin-left: 15px;
        margin-right: 15px;
    }
</style>
